"use client";

import "katex/dist/katex.min.css";
import "@/styles/globals.css";

export default function Styles() {
  return <></>;
}
